<template>
  <v-row>
    <v-col cols="12"
           class="pa-0">
      <v-row class="ma-4">
        <v-col class="text-center pa-0"
               cols="12"
               offset="0"
               md="4"
               offset-md="4"
               lg="2"
               offset-lg="5"
               style="border-bottom: 1px solid black;height:35px">
          <span :class="`${subheaderFontSize} ${backgroundColor}`"
                :style="`position:relative; bottom: -13px; padding: 20px;`">lub</span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import VueOnGeoGlobalMixin from "./vue-ongeo-global-mixin.js";

export default {
  name: "vue-ongeo-or-panel",
  mixins: [VueOnGeoGlobalMixin],
  props: {
    backgroundColor: String
  }
};
</script>
